// extracted by mini-css-extract-plugin
module.exports = {"round_bins":"MemorandumsBinRounds_round_bins__sbQk9"};